import { Flex } from '@chakra-ui/react'
import { Text } from '@chakra-ui/react'
import { ReactNode } from 'react'

import { NetworkErrorIcon } from '../Icons/NetworkErrorIcon'

export interface WidgetErrorProps {
  message?: string
  children?: ReactNode
  variant?: string
}

export const HeadingError = ({ children, message }: WidgetErrorProps) => {
  return (
    <Flex
      direction="column"
      alignItems="center"
      justify="center"
      rounded="lg"
      p="3"
      border="1px"
      borderColor="presets.yellow.30"
      backgroundColor="presets.yellow.5"
      height="55px"
      mt={5}
    >
      <NetworkErrorIcon
        boxSize={6}
        color="presets.yellow.90"
        w="22px"
        h="22px"
        mt={1}
      />
      <Text variant="error" mb={2}>
        Something went wrong...
      </Text>
    </Flex>
  )
}
